import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import Swal from 'sweetalert2';
import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';
import {
    dataTableLanguaje, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, buttonProcessGet, awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection
} from '../../helpers/settings';
import Menu from '../main/Menu';
import CountriesAddEdit from './CountriesAddEdit';
import { countryModelGet } from '../../models/countries/country';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'Countries';

const { app, colors, icons, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { sweetAlert2, } = react;

export default function Countries({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    //const history = useHistory();
    let result;
    let headerObj = {};
    const auth = useAuth();
    let swalProperties = {};
    //const userRole = checkIfUserIsMaster({email: auth?.user?.email || '', languageId: '', subMethod: '', })?.result;
    const [showModal, setShowModal] = useState(false);
    const [processType, setProcessType] = useState();
    const [showLoading, setShowLoading] = useState({ countries: true, });
    //const [showData, setShowData] = useState(false);
    const [btnAddDisable, setBtnAddDisable] = useState(true);
    //#endregion variables

    //#region countries
    let dtCountries = null;
    const dtCountriesId = 'dtCountries';
    const [dtCountriesRowIndexTwo, SetDtCountriesRowIndexTwo] = useState(0);
    const [country, setCountry] = useState(countryModelGet({}));
    //#endregion countries

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnCreate',
            //     className: 'btn btn-outline-warning mx-1',
            // },
            // back: {
            //     id: 'btnBack',
            //     className: '',
            // },
            // close: {
            //     id: 'btnClose',
            //     className: 'close btn-danger fas fa-window-close',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            countries: {
                buttons: {
                    add: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btndtCountriesIdAdd',
                    },
                    delete: {
                        className: 'btn btn-outline-danger float-right btn-sm mx-1',
                        id: 'btndtCountriesIdDelete',
                    },
                },
                icons: {
                    add: {
                        id: 'icondtCountriesIdAdd',
                        className: icons?.plusCircle,
                    },
                    delete: {
                        id: 'icondtCountriesIdDelete',
                        className: icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtCountriesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtCountriesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spdtCountriesIdAdd',
                        className: '',
                    },
                    delete: {
                        id: 'spdtCountriesIdDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: icons?.save,
            // },
            // back: {
            //     id: 'icoBack',
            //     className: icons?.arrowCircleLeft,
            // },
            // close: {
            //     id: 'icoClose',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
            // back: {
            //     id: 'spBack',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region countries (methods)
    const countryAddGetAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'countryAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            setProcessType(0);
            setCountry(
                countryModelGet({
                    userId: auth?.user?.uid,
                })
            );

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            setShowModal(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const countryEditDeleteGetAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'countryEditDeleteGetAsync';
        let response = responseGet();
        try {

            if (processType === 1) {
                setShowLoading({ countries: true, });

                //#region country get
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        languageId: languageObj?.id,
                    },
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCountries}/${id}`,
                };

                result = await axios?.get(
                    headerObj?.url,
                    headerObj,
                );

                response = result?.data || {};
                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ countries: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                setProcessType(processType);
                setCountry(response?.result || {});
                SetDtCountriesRowIndexTwo(rowIndex);
                //#endregion country get

                setShowModal(true);
                setShowLoading({ countries: false, });
            } else if (processType === -1) {
                //#region show message
                let msgTextObj = {
                    one: `${labels?.country?.[languageObj?.id]}: <b>${description}</b><br/>`,
                    two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                };

                swalProperties = {
                    icon: sweetAlert2?.icons?.warning,
                    title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                    html: `${msgTextObj?.one}${msgTextObj?.two}`,
                    timer: null,
                    backdrop: true,
                    confirmButtonColor: colors?.warningColorExp,
                    confirmButtonText: labels?.yes?.[languageObj?.id],
                    showCancelButton: true, //!Swal.isLoading(), //true,
                    cancelButtonColor: colors?.successColorExp,
                    cancelButtonText: labels?.no?.[languageObj?.id],
                    showLoaderOnConfirm: true,
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                    preConfirm: async () => {
                        try {
                            Swal.getCancelButton().hidden = true;
                            Swal?.update({
                                icon: sweetAlert2?.icons?.info,
                                title: `${messages?.processing?.[languageObj?.id]}...`,
                                html: `${msgTextObj?.one}`,
                                showConfirmButton: false,
                            });

                            //#region delete countr
                            headerObj = {
                                headers: {
                                    languageId: languageObj?.id,
                                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                },
                                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCountries}/${id}`
                            };

                            result = await axios.delete(
                                headerObj?.url,
                                headerObj,
                            );

                            response = result?.data || {};

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }
                            //#endregion delete country

                            //#region delete country (dataTable)
                            $(`#${dtCountriesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                            //#endregion delete country (dataTable)

                            //#region data set
                            setCountry({});
                            SetDtCountriesRowIndexTwo(0);
                            //#endregion data set

                            await sendMessageCloseCurrentWindowAsync({
                                msgType: 0,
                                msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                        } catch (ex) {
                            //#region Error
                            response.isSuccess = false;
                            response.msgType = -1;
                            response.msgText = `Method: ${currentMethod}<br/>`;
                            response.msgText += `Error: ${ex?.message}`;
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            //#endregion Error
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                };

                await Swal.fire(swalProperties);
                //#endregion show message
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localShowModalCountryDeleteGet = async (id = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         //#region show modal delete

    //         const swalProperties = {
    //             icon: sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: `${labels?.country?.[languageObj?.id]}: <b>${description}</b><br/>${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
    //             timer: null,
    //             confirmButtonColor: colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         //#endregion show modal delete

    //         //#region delete data

    //         if (isConfirmed) {
    //             sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //             headerObj = {
    //                 headers: {
    //                     authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //                 }
    //             };

    //             //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlCountries}/${id}`, headerObj);
    //             result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlCountries}/${id}`, headerObj);
    //             response = result.data;

    //             if (!response?.isSuccess || response?.isWarning) {
    //                 await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo);
    //                 return;
    //             }

    //             $(`#${dtCountriesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
    //             sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
    //         }

    //         //#endregion delete data
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localShowModalCountryDeleteGet<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo);
    //     }
    //     return response;
    // }
    //#endregion old code
    //#endregion countries (methods)

    //#region others (methods)
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let countriesLocal = [countryModelGet({})];
            //#endregion variables

            setShowLoading({ countries: true, });

            //#region dataTable set
            response = await dataTablesSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ countries: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set

            //#region queryCode set
            response = await queryCodeSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ countries: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion queryCode set

            //#region data get 
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCountries}/`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ countries: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            countriesLocal = response?.result || [];

            countriesLocal?.forEach((detail) => {
                dtRows.push([
                    detail?.description,
                    detail?.alphaCode2,
                    detail?.alphaCode3,
                    detail?.numeric,
                    buttonProcessGet({
                        id: detail?.id,
                        description: detail?.description,
                        showDetails: false,
                        labelDetails: labels?.detail?.[languageObj?.id],
                        enabledDetails: false,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: processEvaluateGet({
                            object: detail,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result,
                        showDelete: true,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: processEvaluateGet({
                            object: detail,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.delete?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result,
                        processButtons: [],
                        subMethod: currentMethod,
                    })?.result
                ]);
            });

            //#region check is enable add button
            isEditLocal = processEvaluateGet({
                object: countriesLocal?.[0],
                property: labels?.process?.en?.toLowerCase(),
                process: labels?.edit?.en?.toLowerCase(),
                subMethod: currentMethod,
            })?.result;

            isDeleteLocal = processEvaluateGet({
                object: countriesLocal?.[0],
                property: labels?.process?.en?.toLowerCase(),
                process: labels?.delete?.en?.toLowerCase(),
                subMethod: currentMethod,
            })?.result;

            setBtnAddDisable(!(isEditLocal && isDeleteLocal));
            //#endregion check is enable add button
            //#endregion data get 

            setShowLoading({ countries: false, });

            //#region load datatable
            $(`#${dtCountriesId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion load datatable
        } catch (ex) {
            setShowLoading({ countries: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtCountriesId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '50%', },
                    { title: labels?.alphaCode2, width: '15%', },
                    { title: labels?.alphaCode3, width: '15%', },
                    { title: labels?.numeric, width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtCountriesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSetAsync = async ({
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtCountriesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtCountriesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            countryEditDeleteGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            //localShowModalCountryDeleteGet(id, description, dtRowIndex);
                            countryEditDeleteGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.countries?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.countries?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.countries?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.countries?.icons?.add?.id}`)?.addClass(controls?.dataTables?.countries?.icons?.add?.className);
                    $(`#${controls?.dataTables?.countries?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.countries?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.countries?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.countries?.spinners?.add?.className);


                    $(`#${controls?.dataTables?.countries?.icons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.countries?.buttons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.countries?.spinners?.delete?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.countries?.icons?.delete?.id}`)?.addClass(controls?.dataTables?.countries?.icons?.delete?.className);
                    $(`#${controls?.dataTables?.countries?.buttons?.delete?.id}`)?.addClass(controls?.dataTables?.countries?.buttons?.delete?.className);
                    $(`#${controls?.dataTables?.countries?.spinners?.delete?.id}`)?.addClass(controls?.dataTables?.countries?.spinners?.delete?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.countries?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.countries?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.countries?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.countries?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.countries?.buttons?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.countries?.buttons?.delete?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [auth]) // eslint-disable-line react-hooks/exhaustive-deps

    //#endregion others (methods)

    return (
        <div>
            <Menu viewName='settings' process='countries' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.countries?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.countries?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.countries}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.countries?.[languageObj?.id]}
                                                style={styles?.cardHeaderLogo}
                                                src={globalSettings?.images?.countriesLogo}></img> - {labels?.index?.[languageObj?.id]}
                                        </h6>
                                        {/* <div className='card-tools'> */}
                                        {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right btn-sm' onClick={(e) => null}><i className={globalSettings?.icons?.plusCircle}></i></button> */}
                                        {/* </div> */}

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>

                                    </div> {/*card header*/}

                                    <div className='card-body'>

                                        {/* <div className='dataTables_wrapper dt-bootstrap4'> */}
                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/*{showData ?*/}
                                                {/* <div> */}
                                                <button id={controls?.dataTables?.countries?.buttons?.add?.id}
                                                    className={controls?.dataTables?.countries?.buttons?.add?.className}
                                                    disabled={btnAddDisable}
                                                    tooltip='tooltip'
                                                    title={labels?.add?.[languageObj?.id]}
                                                    onClick={(e) => countryAddGetAsync({ e: e, subMethod: 'btn - countryAdd', })}>
                                                    <i id={controls?.dataTables?.countries?.icons?.add?.id} className={controls?.dataTables?.countries?.icons?.add?.className} /> <span id={controls?.dataTables?.countries?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtCountriesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>

                                        {/* </div> */}

                                    </div> {/*card body*/}

                                    <div className='card-footer'>

                                    </div> {/*card footer*/}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModal ?
                <CountriesAddEdit $={$}
                    auth={auth}
                    country={country}
                    setCountry={setCountry}
                    dtId={dtCountriesId}
                    dtObj={dtCountries}
                    dtRowIndex={dtCountriesRowIndexTwo}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}